import { mode } from '@chakra-ui/theme-tools';

// Modal — polished overlay with consistent radius, spacing, backdrop blur
export const modalStyles = {
  components: {
    Modal: {
      baseStyle: props => ({
        dialog: {
          borderRadius: '2xl', // 16px — elevated surface rounding
          bg: mode('white', 'navy.800')(props),
          boxShadow: '2xl',
          // Subtle border so the modal floats clearly on dark overlays
          borderWidth: '1px',
          borderColor: mode('gray.100', 'whiteAlpha.100')(props),
        },
        header: {
          fontSize: 'lg',
          fontWeight: 'semibold',
          px: 6,
          py: 5,
          borderBottomWidth: '1px',
          borderBottomColor: mode('gray.100', 'whiteAlpha.100')(props),
          color: mode('gray.800', 'white')(props),
        },
        body: {
          px: 6,
          py: 5,
          fontSize: 'sm',
          color: mode('gray.700', 'gray.300')(props),
        },
        footer: {
          px: 6,
          py: 4,
          borderTopWidth: '1px',
          borderTopColor: mode('gray.100', 'whiteAlpha.100')(props),
          gap: 3,
        },
        overlay: {
          // Soft backdrop: semi-transparent with subtle blur
          backdropFilter: 'blur(4px)',
          bg: mode('blackAlpha.400', 'blackAlpha.700')(props),
        },
        closeButton: {
          top: '14px',
          right: '16px',
          borderRadius: 'lg',
          _hover: { bg: mode('gray.100', 'whiteAlpha.100')(props) },
        },
      }),
    },
    Drawer: {
      baseStyle: props => ({
        dialog: {
          bg: mode('white', 'navy.800')(props),
        },
        header: {
          fontSize: 'lg',
          fontWeight: 'semibold',
          px: 6,
          py: 5,
          borderBottomWidth: '1px',
          borderBottomColor: mode('gray.100', 'whiteAlpha.100')(props),
        },
        body: {
          px: 6,
          py: 5,
          fontSize: 'sm',
        },
        footer: {
          px: 6,
          py: 4,
          borderTopWidth: '1px',
          borderTopColor: mode('gray.100', 'whiteAlpha.100')(props),
          gap: 3,
        },
      }),
    },
  },
};
